import { AccountItem, FrameConsumer } from "@weezevent/nacre";
import { useSelector } from "react-redux";
import { useAuth } from "react-oidc-context";
import React from "react";
import { useTranslation } from "react-i18next";

const AccountComponent = () => {
	const { t } = useTranslation();
	const auth = useAuth();
	const organization = useSelector(state => state.organization.organization);
	const exports = useSelector(state => state.exports);

	/**
	 * @function showPromptMessage
	 * @description display prompt message and avoid quit the export pages
	 * @return {Boolean} - true if the user would like to quit
	 */
	function showPromptMessage(event) {
		let confirm = true;

		if (Object.keys(exports).length) {
			confirm = window.confirm(
				t("access.configuration.exportConfirmModal")
			);
			if (!confirm) {
				event.preventDefault();
			}
		}

		return confirm;
	}

	/**
	 * @function handleSettings
	 * @description Redirect the user until his account
	 * @param  {Object} event - data of the event
	 */
	function handleSettings(event) {
		// PromptMessage has to be validated to pass
		if (!showPromptMessage(event)) {
			return;
		}
		window.location = `${auth.settings.authority}/account`;
	}

	/**
	 * @function logout
	 * @description Manage the logout of the user
	 * @param  {Object} event - data of the event
	 */
	function logout(event) {
		// PromptMessage has to be validated to pass
		if (!showPromptMessage(event)) {
			return;
		}

		auth.removeUser();
		auth.logoutRedirect();
	}

	const profile = auth.user.profile;

	const name =
		profile.name ||
		`${profile.data?.firstname || ""} ${profile.data?.name || ""}`;

	return (
		<FrameConsumer.Module>
			<FrameConsumer.Module.Apps>
				<FrameConsumer.Module.Apps.Ticket
					as="a"
					href={`${
						window.weezConfig.front.weezeventAdminUrl
					}/ticket/O${organization.id()}/`}
					label={t("access.modules.universes.ticketing")}
					target="_blank"
				/>
				{Boolean(organization) && (
					<FrameConsumer.Module.Apps.Target
						as="a"
						href={`${
							window.weezConfig.front.weezeventAdminUrl
						}/target/O${organization.id()}/home`}
						label={t("access.modules.universes.target")}
						target="_blank"
						key="weeztarget"
					/>
				)}
				{Boolean(organization && organization.hasCashlessConfig()) && (
					<FrameConsumer.Module.Apps.Pay
						as="a"
						href={`${
							window.weezConfig.front.weezeventCashless
						}/#!/${organization.id()}`}
						label={t("access.modules.universes.pay")}
						target="_blank"
						key="weezpay"
					/>
				)}
			</FrameConsumer.Module.Apps>

			<FrameConsumer.Module.Account
				content={name}
				items={
					<AccountItem
						subtitle={t("access.common.profile")}
						title={name}
						mail={profile.email || profile.data?.email || ""}
						primary={{
							onClick: handleSettings,
							label: t("access.common.account")
						}}
						secondary={{
							onClick: logout,
							label: t("access.common.logout"),
							as: "a",
							href: `${
								window.weezConfig.temporary.menhirUrl
							}logout`
						}}
					/>
				}
			/>
		</FrameConsumer.Module>
	);
};

export default AccountComponent;
